import { F0Card } from '@factorialco/f0-react'

import i18n from 'modules/core/lib/i18n'

import { LatestUpdatesItemProps } from 'modules/marketplace_modules/components/Revamp/types'

export const Item = ({ image, title, description, onClick }: LatestUpdatesItemProps) => {
  return (
    <F0Card
      image={image}
      title={title}
      description={description}
      secondaryActions={[
        {
          label: i18n.t('marketplace.revamp.read_more'),
          onClick: onClick,
        },
      ]}
    />
  )
}
